<template>

  <div class="container">
    <hr>
    <b-row>
      <b-col cols="3">
        <b-link href="https://www.virtualeduca.org/" target="_blank">
          <b-img width="250" height="auto" left src="../../../static/img/enlaces/virtualeduca.png"/>
        </b-link>
      </b-col>
      <b-col cols="3">
        <b-link href="https://www.ovtt.org/" target="_blank">
          <b-img width="250" height="auto" right src="../../../static/img/enlaces/ovtt.png" style="padding-top: 10%;"/>
        </b-link>
      </b-col>
      <!--<b-col cols="3" offset="">
        <b-link href="https://tec.mx/es" target="_blank">
          <b-img width="250" height="auto" left src="../../../static/img/enlaces/tecmonterrey.png"
                 style="padding-top: 10%;"/>
        </b-link>
      </b-col>-->
      <b-col cols="3">
        <b-link href="http://www.ricyt.org/" target="_blank">
          <b-img width="250" height="auto" right src="../../../static/img/enlaces/ricyt.png" style="padding-top: 10%;"/>
        </b-link>
      </b-col>
      <b-col cols="3">
        <b-link href="https://observatorio.itesm.mx/" target="_blank">
          <b-img width="250" height="auto" right src="../../../static/img/enlaces/obine.png" style="padding-top: 10%;"/>
        </b-link>
      </b-col>
    </b-row>

    <b-row>
      <!--<b-col cols="3">
        <b-link href="http://www.ricyt.org/" target="_blank">
          <b-img width="250" height="auto" right src="../../../static/img/enlaces/ricyt.png" style="padding-top: 10%;"/>
        </b-link>
      </b-col>-->
    </b-row>
  </div>
</template>

<script>

  export default {
    name: "enlacesInteres",
    props: [
      //'title'
    ],
    computed: {
    }
  }
</script>

<style scoped>
  img:hover {
    /*background-color: #D5D9DE;*/
    color: #1E3375;
    -ms-transform: scale(1.5); /* IE 9 */
    -webkit-transform: scale(1.5); /* Safari 3-8 */
    transform: scale(1.5);
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/frontend/enlacesInteres.vue